import { DropDown } from "./DropDown";

export function GroupByType(options: {
    val: string | undefined, display: string
}[], selected: string | undefined, onSelectionChanged: (selected: string | undefined) => void, showTotal: boolean = true, label?: string) {
    const currentOptions = showTotal ? ([{ val: undefined, display: 'Total' }] as {
        val: string | undefined, display: string
    }[]).concat(options) : options

    return DropDown('GroupByType', currentOptions, selected, onSelectionChanged, label)
}


// WEBPACK FOOTER //
// ./src/components/GroupByType.tsx